<!-- UI desktop -->
<button class="ant-btn ant-btn-primary d-flex align-items-center" (click)="configMode == 'basic' ? configMode = 'advanced' : configMode = 'basic'">
  <i nz-icon nzType="setting" nzTheme="outline"></i> 
  <span>{{(configMode == 'basic' ? 'cau_hinh_nang_cao' : 'cau_hinh_co_ban') | translate}}</span>
</button>
<!-- Cấu hình cơ bản -->
<ng-container *ngIf="configMode == 'basic'">
  <div style="margin-top: 10px">
    <div class="container-font">
      <!-- chọn ngôn ngữ đa ngôn ngữ -->
      <div class="mb-3">
        <p>{{'dinh_dang_chu_goi_y' | translate}}</p>
      </div>
      <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung_chu_goi_y' | translate}}</mat-label>
              <textarea style="padding-top: 7px" matInput
                  [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component" 
                  (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event"  
                  (blur)="updateContent('input_text_placeholder')"></textarea>
          </mat-form-field>
      </div>

      <app-text-format-config
          [device]="device"
          [objectChoosing]="objectChoosing"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [textContentClass]="class['search-snimei__placeholder']"
          [textWrapperClass]="class['search-snimei__placeholder']"
          >
      </app-text-format-config>
    </div>

    <p>{{'dinh_dang_chu_khi_nhap' | translate}}</p>
    <app-text-format-config
                  [device]="device"
                  [objectChoosing]="objectChoosing"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['search-snimei']"
                  [textWrapperClass]="class['search-snimei']"
                  >
          </app-text-format-config>
  </div>
</ng-container>

<div class="contains-main" *ngIf="!isViewAll && configMode == 'advanced'">
  <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Hiển thị -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
          <div class="main-config">
              
              <!-- Lựa chọn hiển thị cho các thiết bị -->
              <app-hide-show-config
                  [device]="device"
                  [elementChoosing]="objectChoosing">
              </app-hide-show-config>
          </div>
      </li>

      <!-- Cấu hình ô tìm kiếm -->
       <!-- Định dạng chữ gợi ý -->
       <li nz-submenu nzTitle="{{'dinh_dang_chu_goi_y' | translate}}">
          <div class="container-font">
              <!-- chọn ngôn ngữ đa ngôn ngữ -->
              <div class="mb-3">
                  
              </div>
              <div class="config-text" style="width: 100%">
                  <mat-form-field style="width: 100%">
                      <mat-label>{{'noi_dung_chu_goi_y' | translate}}</mat-label>
                      <textarea style="padding-top: 7px" matInput
                          [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component" 
                          (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event"  
                          (blur)="updateContent('input_text_placeholder')"></textarea>
                  </mat-form-field>
              </div>

              <app-text-format-config
                  [device]="device"
                  [objectChoosing]="objectChoosing"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['search-snimei__placeholder']"
                  [textWrapperClass]="class['search-snimei__placeholder']"
                  >
              </app-text-format-config>
          </div>
      </li>
      <!-- Định dạng chữ khi nhập -->
      <li nz-submenu nzTitle="{{'dinh_dang_chu_khi_nhap' | translate}}">
          <app-text-format-config
                  [device]="device"
                  [objectChoosing]="objectChoosing"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['search-snimei']"
                  [textWrapperClass]="class['search-snimei']"
                  >
          </app-text-format-config>
      </li>
      <!-- Định dạng ô -->
      <li nz-submenu nzTitle="{{'tuy_chinh_kieu_vien' | translate}}">
          <div class="main-config">
              <app-borders-config [device]="device"
                                  [class]="class"
                                  [borderClass]="class['search-snimei']"
                                  [id_object]="objectChoosing._id"
                                  [elementChoosing]="objectChoosing"
              >
              </app-borders-config>
              
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                  <p (click)="openViewAll(stylefields[0])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
          </div>
          
      </li>
      <!-- Bật đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}">
          <app-shadow-config 
              [device]="device"
              [config]="config"
              [class]="class"
              [shadowClass]="class['search-snimei']"
              [shadowConfig]="config['box-shadow']"
              [objectChoosing]="objectChoosing"
              >
          </app-shadow-config>
          
      </li>
      <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
          <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
                ></button>
          </div>
          <div class="config-name" style="padding-left: 5px;">
              <p>{{'mau_nen' | translate}}</p>
              <input class="input-color" type="button" 
                  [style.background]="class['search-snimei']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['search-snimei']['background-color']"
                  (colorPickerClose)="updateClass()" />
          </div>
      </li>
      <!-- Kết nối trang tìm kiếm -->
      <li nz-submenu nzTitle="{{'ket_noi_trang_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <app-link-page-config [staticdata]="staticdata" [id_object]="objectChoosing._id" [blocks_of_page]="blocks_of_page" [type_page]="['detail_product']"></app-link-page-config>
      </li>
</ul>
</div>

<div class="editor-content" *ngIf="isViewAll">
  <div
    class="return"
    (click)="isViewAll = !isViewAll"
    style="
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      margin-bottom: 5px;
    "
  >
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll" 
            style="font-weight: 500;">
          {{ currentViewAll.title | translate }}</span>
  </div>
</div>

<div class="view-more" *ngIf="isViewAll">
  <!-- Cấu hình chi tiết viền của ô tìm kiếm -->
  <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
                  [device]="device"
                  [class]="class"
                  [borderRadiusClass]="class['search-snimei']"
                  [id_object]="objectChoosing._id"
                  [elementChoosing]="objectChoosing"
      >
      </app-borders-radius-config>
  </div>
</div>
